import src from "IMAGE";
export default { src, width: 127, height: 96, blurWidth: 0, blurHeight: 0};
